import { env } from '@/env.mjs'

// Locales are defined in i18n/routing via defineRouting
export const APP_LOCALES = env.NEXT_PUBLIC_LOCALIZATION_ENABLED ? ['en', 'es', 'fr', 'de'] : ['en']
export const APP_DEFAULT_LOCALE = 'en'

export const LOCALE_TRANSLATION = {
	en: 'English',
	es: 'Español',
	fr: 'Français',
	de: 'Deutsch',
}
